module.exports = __webpack_public_path__ + "img/knight4cf_01.4c607c5c.jpg";